import { ApplicationConfig } from '@angular/core';
import { provideRouter, UrlSerializer, withComponentInputBinding, withInMemoryScrolling } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';

import { routes } from './app.routes';
import { authInterceptor } from './interceptors/auth.interceptor';
import { decryptInterceptor } from './interceptors/decrypt.interceptor';
import { PipeFriendlyUrlSerializer } from './pipe-friendly-url.serializer';
import { provideAnimations } from '@angular/platform-browser/animations';
import { MessageService } from 'primeng/api';

export const appConfig: ApplicationConfig = {
  providers: [
    // PathLocationStrategy (no hash) is the default - URLs will be like /profile instead of /#/profile
    provideRouter(
      routes,
      withComponentInputBinding(),
      withInMemoryScrolling({ scrollPositionRestoration: 'top' })
    ),
    provideAnimations(),
    { provide: UrlSerializer, useClass: PipeFriendlyUrlSerializer },
    provideHttpClient(withInterceptors([authInterceptor, decryptInterceptor])),
    MessageService
  ]
};
